import * as React from 'react';

import classnames from 'classnames';

import styles from './grey-section.module.css';

type Props = {
    content: React.ReactNode;
    isFullHeight?: boolean;
    centerContent?: boolean;
    noMargin?: boolean;
};

export function GreySection(props: Props) {
    const {isFullHeight, centerContent, noMargin} = props;

    const styleName = classnames(styles['section-container'], {
        [styles['section-container--full-height']]: isFullHeight,
        [styles['section-container--center-content']]: centerContent,
        [styles['section-container--no-margin']]: noMargin,
    });

    return <div className={styleName}>{props.content}</div>;
}
